<template>
  <div class="bill-verification-record tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('fms_billVerificationRecord.htbhjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-form-item style="float: right">
          <el-radio-group v-model="formSearch.includeTrades" @change="onPageChange({ page: 1 })">
            <el-radio-button :label="0">{{ $t('Common.com_all') }}</el-radio-button>
            <el-radio-button :label="1">1:{{ $t('fms_billVerificationRecord.Nzhang_dan') }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('fms_billVerificationRecord.fu_kuan_gong_si')">
          <el-input v-model="formSearch.payableOrgName" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_billVerificationRecord.dao_qi_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.billPaymentTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_billVerificationRecord.qrskrq')">
          <custom-date-picker style="width: 100%" v-model="formSearch.receiveConfirmTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_billVerificationRecord.yhskrq')">
          <custom-date-picker style="width: 100%" v-model="formSearch.tradeConfirmTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_billVerificationRecord.fkfyhzh')">
          <el-input v-model="formSearch.buyerAccount" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_billVerificationRecord.liu_shui_hao')">
          <el-input v-model="formSearch.sellerTradeCode" :clearable="true"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" :index="true" @filter="filterChange" @sort="sortChange" :slots="['termNum', 'billTradeAmount', 'bodyNum', 'contractNo']">
        <template v-slot:billTradeAmount="scope">
          <div v-if="scope.row.billTradeAmount > 0">{{ scope.row.billTradeAmount }}</div>
          <div v-else style="color: red">{{ scope.row.billTradeAmount }}</div>
        </template>
        <template v-slot:termNum="scope">
          <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <template v-slot:bodyNum="scope">
          <div class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</div>
        </template>
        <template v-slot:contractNo="scope">
          <div class="cell-link" @click="jump('/contractdetail', { contractId: scope.row.orderId, contractClass: scope.row.orderClass, parentPath: $route.path })">
            {{ scope.row.contractNo }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';

export default {
  name: 'billVerificationRecord',
  mixins: [resetFormSearchMixins],
  data() {
    return {
      tableCode: 'bill_verification_record',
      formSearch: {
        payableOrgName: '',
        billPaymentTime: [],
        receiveConfirmTime: [],
        tradeConfirmTime: [],
        buyerAccount: '',
        sellerTradeCode: '',
        includeTrades: 0,
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        applyOrgName: '',
        applyTime: '',
      },
      tableList: [],
      totalRows: null,
      link: null,
    };
  },
  activated: function () {},
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
    this.formSearch.receiveConfirmTime = [this.$momentWorld(this.$moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(this.$moment().format('YYYY-MM-DD 23:59:59'))];
    this.getTableList();
  },
  methods: {
    // 获取产品列表
    getTableList: function () {
      this.formSearch.billPaymentTimeStart = this.formSearch.billPaymentTime && this.formSearch.billPaymentTime[0] ? this.$momentWorld(this.formSearch.billPaymentTime[0]) : undefined;
      this.formSearch.billPaymentTimeEnd = this.formSearch.billPaymentTime && this.formSearch.billPaymentTime[1] ? this.$momentWorld(this.formSearch.billPaymentTime[1]) : undefined;
      this.formSearch.receiveConfirmTimeStart = this.formSearch.receiveConfirmTime && this.formSearch.receiveConfirmTime[0] ? this.$momentWorld(this.formSearch.receiveConfirmTime[0]) : undefined;
      this.formSearch.receiveConfirmTimeEnd = this.formSearch.receiveConfirmTime && this.formSearch.receiveConfirmTime[1] ? this.$momentWorld(this.formSearch.receiveConfirmTime[1]) : undefined;
      this.formSearch.tradeConfirmTimeStart = this.formSearch.tradeConfirmTime && this.formSearch.tradeConfirmTime[0] ? this.$momentWorld(this.formSearch.tradeConfirmTime[0]) : undefined;
      this.formSearch.tradeConfirmTimeEnd = this.formSearch.tradeConfirmTime && this.formSearch.tradeConfirmTime[1] ? this.$momentWorld(this.formSearch.tradeConfirmTime[1]) : undefined;
      this.$getJSON(apis.billVerifyRecordPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.billVerifyRecordExport, this.formSearch).then(() => {});
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
</style>
